import "./Loader.scss"

const Loader = () => {
    return (<span className="uiloader"></span>)
}

export default Loader;